import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  exams: [],
};

const eyeExamSlice = createSlice({
  name: "eyeExam",
  initialState,
  reducers: {
    addExam: (state, action) => {
      state.exams.push(action.payload);
    },
  },
});

export const { addExam } = eyeExamSlice.actions;
export default eyeExamSlice.reducer;
